module.exports = "https://www.gc-pro.gnp.com.mx/29e1d21d07826b9a12e6ef10259fce95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-contratante-gm.svg
// module id = 8081
// module chunks = 0